module.exports = __webpack_public_path__ + "static/media/finals-2.d6036294.png";